import React from "react";
import { DatePicker, Form, Input, InputNumber } from "antd";
import dayjs from "dayjs";

function ProjectProgressSection({ revisedEndDate }) {
  return (
    <>
      <div className="custom-title !bg-white !p-0 mt-[1.25rem]">
        Project Progress
      </div>
      <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
        <Form.Item
          label="Inspection Date"
          name="mrEvalDate"
          rules={[
            {
              required: true,
              message: "inspection date is required",
            },
          ]}
        >
          <DatePicker format={"YYYY MMM DD"} className="input" />
        </Form.Item>

        <Form.Item
          label="Commencement Date"
          name="mrCommencementDate"
          rules={[
            {
              required: true,
              message: "Commencement date is required",
            },
          ]}
        >
          <DatePicker disabled format={"YYYY MMM DD"} className="input" />
        </Form.Item>
        <Form.Item
          label="Expected Date of Completion"
          name="mrExpectedCompletionDate"
          rules={[
            {
              required: true,
              message: "Expected date of completion is required",
            },
          ]}
        >
          <DatePicker disabled format={"YYYY MMM DD"} className="input" />
        </Form.Item>
        {/* From the project's Revised End Date. No "name": shown, not saved
            with the report - the report reads it from the project. */}
        <Form.Item label="Revised Completion Date">
          <DatePicker
            disabled
            format={"YYYY MMM DD"}
            className="input"
            placeholder="Not revised"
            value={revisedEndDate ? dayjs(revisedEndDate) : null}
          />
        </Form.Item>
      </div>
      <div className="grid lg:grid-cols-3 grid-cols-1 lg:gap-x-10">
        <Form.Item
          name="mrDaysElapsed"
          label={"Days elapsed"}
          rules={[
            {
              required: true,
              message: "Please add days elapsed",
            },
          ]}
        >
          <Input disabled className="input" />
        </Form.Item>
        <Form.Item
          name="mrPercentageElapsedDay"
          label={"% Days Lapsed"}
          rules={[
            {
              required: true,
              message: "Please add % Days lapsed",
            },
          ]}
        >
          <Input disabled className="input" />
        </Form.Item>
        <Form.Item
          name="mrPhysicalProgres"
          label={"Physical Progress"}
          rules={[
            {
              required: true,
              message: "Please add physical progress",
            },
          ]}
        >
          <InputNumber
            disabled
            max="100"
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
            className="input flex"
          />
        </Form.Item>
      </div>
    </>
  );
}

export default ProjectProgressSection;
